import type { VoiceType } from '@shared/protocol';
import { frequencyToNote } from './noteMap';

// Voice type ranges: [lowest_midi, highest_midi]
const VOICE_RANGES: { type: VoiceType; min: number; max: number }[] = [
  { type: 'Bass',          min: 40, max: 64  }, // E2–E4
  { type: 'Baritone',      min: 43, max: 67  }, // G2–G4
  { type: 'Tenor',         min: 48, max: 72  }, // C3–C5
  { type: 'Alto',          min: 53, max: 77  }, // F3–F5
  { type: 'Mezzo-Soprano', min: 57, max: 81  }, // A3–A5
  { type: 'Soprano',       min: 60, max: 84  }, // C4–C6
];

const SINGER_MAP: Record<VoiceType, string[]> = {
  'Bass':          ['Barry White', 'Johnny Cash', 'Vin Diesel'],
  'Baritone':      ['Elvis Presley', 'Frank Sinatra', 'Michael Jackson'],
  'Tenor':         ['Freddie Mercury', 'Stevie Wonder', 'Bruno Mars'],
  'Alto':          ['Amy Winehouse', 'Adele', 'Cher'],
  'Mezzo-Soprano': ['Beyoncé', 'Lady Gaga', 'Whitney Houston'],
  'Soprano':       ['Mariah Carey', 'Celine Dion', 'Ariana Grande'],
  'Unknown':       [],
};

export function classifyVoiceType(lowestHz: number, highestHz: number): VoiceType {
  const lowestMidi  = Math.round(69 + 12 * Math.log2(lowestHz  / 440));
  const highestMidi = Math.round(69 + 12 * Math.log2(highestHz / 440));
  const midMidi = (lowestMidi + highestMidi) / 2;

  let best: VoiceType = 'Unknown';
  let bestScore = Infinity;

  for (const vr of VOICE_RANGES) {
    const vrMid = (vr.min + vr.max) / 2;
    const score = Math.abs(midMidi - vrMid);
    if (score < bestScore) { bestScore = score; best = vr.type; }
  }
  return best;
}

export function getSingerComparisons(type: VoiceType): string[] {
  return SINGER_MAP[type] ?? [];
}

export function rangeDescription(lowestHz: number, highestHz: number): string {
  const lo = frequencyToNote(lowestHz);
  const hi = frequencyToNote(highestHz);
  const semitones = Math.round(12 * Math.log2(highestHz / lowestHz));
  const octaves = (semitones / 12).toFixed(1);
  return `${lo.fullName} – ${hi.fullName} (${semitones} semitones, ${octaves} octaves)`;
}
